"use strict";

exports.__esModule = true;
exports.LayoutButtons = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _VimanaIcon = require("../../VimanaIcon");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var VimanaIconsButtonGroup = (0, _styledComponents["default"])(_core.ButtonGroup).withConfig({
  displayName: "LayoutButtons__VimanaIconsButtonGroup",
  componentId: "sc-cuupzb-0"
})(["button{height:30px;padding:3px;}"]);
var LayoutButtons = exports.LayoutButtons = /*#__PURE__*/function (_Component) {
  function LayoutButtons() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(LayoutButtons, _Component);
  var _proto = LayoutButtons.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      selected = _this$props.selected,
      showDetails = _this$props.showDetails,
      showGrid = _this$props.showGrid,
      showList = _this$props.showList,
      showAccordian = _this$props.showAccordian,
      onChangeLayout = _this$props.onChangeLayout;
    return /*#__PURE__*/_react["default"].createElement(VimanaIconsButtonGroup, {
      style: {
        marginRight: "5px"
      }
    }, showAccordian ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: selected === "accordian",
      onClick: function onClick() {
        return onChangeLayout("accordian");
      }
    }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
      margin: "0px",
      iconSize: 24,
      icon: _icons.IconNames.VERTICAL_DISTRIBUTION,
      active: selected === "thumbnails",
      alt: "Grid view"
    })) : null, showDetails ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: selected === "details",
      onClick: function onClick() {
        return onChangeLayout("details");
      }
    }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
      margin: "0px",
      iconSize: 24,
      icon: "CompactListIcon",
      active: selected === "details",
      alt: "Details view"
    })) : null, showList ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: selected === "list",
      onClick: function onClick() {
        return onChangeLayout("list");
      }
    }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
      margin: "0px",
      iconSize: 24,
      icon: "ListDetailsLayoutIcon",
      alt: "List view"
    })) : null, showGrid ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      active: selected === "thumbnails",
      onClick: function onClick() {
        return onChangeLayout("thumbnails");
      }
    }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
      margin: "0px",
      iconSize: 24,
      icon: "GridLayoutIcon",
      active: selected === "thumbnails",
      alt: "Grid view"
    })) : null);
  };
  return LayoutButtons;
}(_react.Component);
LayoutButtons.defaultProps = {
  showList: true,
  showGrid: true,
  showDetails: true,
  showAccordian: true,
  selected: "details"
};